import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Point from "../page/Point";

const routes: AppRouteType[] = [
  {
    path: slugs.point,
    component: Point,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
